import Nav from "./js/components/Nav";
import Video from "./js/components/Video";
import Animation from "./js/components/Animation";
import Share from "./js/components/Share";
import Footer from "./js/components/Footer";
import Gallery from "./js/components/Gallery";
import Summary from "./js/components/Summary";
import "./forms";

// TODO: lazy load Animation due to lottie dep in Animation
window.addEventListener("load", () => {
    Nav();
    Video();
    Animation();
    Share();
    Footer();
    Gallery();
    Summary();
});
